import React, { useState, useEffect } from 'react';
import sparkles from '../../assets/icons8-sparkle-24.png';
import TextAreaTail from '../tailwind/textarea-tail';
import { useAuth } from '../../contexts/AuthContext';
import { PlusIcon } from '@heroicons/react/20/solid'
import { MinusIcon } from '@heroicons/react/20/solid'
import { generateCopy } from '../../clients/copyClient';
import SpeechToText from './speech-to-text';

export default function LinkedInCopyForm({ updateCopy, email, credits, setOpenSubscriptionModal, showCopyNotification, setSelectedTool }) {
    const [offer, setOffer] = useState(localStorage.getItem('offer') || '');
    const [linkedInProfileUrl, setLinkedInProfileUrl] = useState(localStorage.getItem('linkedInProfileUrl') || '');
    const [pain, setPain] = useState(localStorage.getItem('pain') || '');
    const [caseStudies, setCaseStudies] = useState(localStorage.getItem('caseStudies') || '');
    const [callToAction, setCallToAction] = useState(localStorage.getItem('callToAction') || '');
    const [tone, setTone] = useState(localStorage.getItem('tone') || '');
    const [wordCount, setWordCount] = useState(localStorage.getItem('wordCount') || '');
    const [readingLevel, setReadingLevel] = useState(localStorage.getItem('readingLevel') || '');
    const [speech, setSpeech] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [transcribedText, setTranscribedText] = useState('');
    const [showAdvanced, setShowAdvanced] = useState(false);
    const { authToken } = useAuth();

    useEffect(() => {
        localStorage.setItem('offer', offer);
        localStorage.setItem('linkedInProfileUrl', linkedInProfileUrl);
        localStorage.setItem('pain', pain);
        localStorage.setItem('caseStudies', caseStudies);
        localStorage.setItem('callToAction', callToAction);
        localStorage.setItem('tone', tone);
        localStorage.setItem('wordCount', wordCount);
        localStorage.setItem('readingLevel', readingLevel);
    }, [offer, pain, caseStudies, linkedInProfileUrl, callToAction, tone, wordCount, readingLevel]);

    const handleTextChange = (text) => {
        setTranscribedText(text);
        // Call any other function or perform any action with the transcribed text
        console.log('Transcribed Text:', text);
    };

    const generate = async (event) => {
        localStorage.setItem('type', 'linkedin')
        try {
            setIsLoading(true);
            const copy = await generateCopy(email, authToken, 'linkedin');
            updateCopy(copy);
        } catch (error) {
            console.error('Failed to fetch:', error);
        } finally {
            setIsLoading(false);
        }
    };

    function clear() {
        setOffer('');
        setLinkedInProfileUrl('');
        setPain('');
        setCaseStudies('');
        setCallToAction('');
        setTone('');
        setWordCount('');
        setReadingLevel('');
    }

    return (
        <>
            {/* <div>
                <h1>Speech to Text Demo</h1>
                <SpeechToText onTextChange={handleTextChange} />
                <p>Transcribed Text: {transcribedText}</p>
            </div> */}

            <div className="w-full mb-4 sm:mb-8">
                <TextAreaTail label="Your offer" description="Briefly describe the product or services you're selling." setSomething={setOffer} value={offer} characterGoal={25} placeholder="An AI copywriter that generates email copy for B2B cold outreach" />
            </div>
            <div className="w-full mb-4 sm:mb-8">
                <TextAreaTail label="Customer's pain point" description="Describe the problem your offer solves." setSomething={setPain} value={pain} characterGoal={35} placeholder="Writing copy that converts is difficult and extremely time consuming" />
            </div>
            <div className="w-full mb-4 sm:mb-8">
                <TextAreaTail label="Prospect's LinkedIn profile url" description="(if you want a personalized email)" setSomething={setLinkedInProfileUrl} value={linkedInProfileUrl} placeholder="https://www.linkedin.com/in/adam-gusky-33239910a/" />
            </div>
            <div className="w-full mb-4 sm:mb-8">
                <TextAreaTail label="Case studies or metrics (optional)" description="Describe any previous results you've achieved." setSomething={setCaseStudies} value={caseStudies} placeholder="Generate high quality copy in under ten seconds" />
            </div>
            {showAdvanced && (
                <>
                    <div className="w-full text-start flex space-x-4">
                        <div className="w-full mb-4 sm:mb-8">
                            <TextAreaTail label="Call to action" description="Describe what you want to get out of this email." setSomething={setCallToAction} value={callToAction} placeholder="Interested in learning more?" />
                        </div>
                        <div className="w-full mb-4 sm:mb-8">
                            <TextAreaTail label="Tone" description="Describe the tone you want the email written with." setSomething={setTone} value={tone} placeholder="Friendly and persuasive" />
                        </div>
                    </div>
                    <div className="w-full text-start flex space-x-4">

                        <div className="w-full mb-4 sm:mb-8">
                            <TextAreaTail label="Word count" description="Select the length of the email in number of words." setSomething={setWordCount} value={wordCount} placeholder="90" />
                        </div>
                        <div className="w-full mb-4 sm:mb-8">
                            <TextAreaTail label="Reading level" description="Select the reading level you want the email written with." setSomething={setReadingLevel} value={readingLevel} placeholder="5th grade" />
                        </div>
                    </div>
                </>
            )}
            <div className={`w-full flex flex-col sm:flex-row justify-between space-x-4 text-start sm:text-end`}>
                <button
                    type="button"
                    className={`mb-3 rounded-full px-4 py-2.5 text-md font-semibold border-2 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${showAdvanced ? 'bg-white text-custom-orange border-custom-orange' : 'bg-custom-orange text-white border-white'}`}
                    onClick={() => setShowAdvanced(!showAdvanced)}
                >
                    <div className="flex items-center">
                        {showAdvanced ?
                            <MinusIcon className="h-5 w-5 flex-none text-custom-orange" aria-hidden="true" /> :
                            <PlusIcon className="h-5 w-5 flex-none text-white" aria-hidden="true" />
                        }
                        More fields
                    </div>
                </button>
                <div className="flex space-x-4 mb-3 sm:mb-0">
                    <button
                        type="button"
                        className="mb-3 rounded-full bg-white px-4 py-2.5 text-md font-semibold text-custom-orange border-2 border-custom-orange shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                        onClick={clear}>
                        Clear
                    </button>
                    <button
                        type="button"
                        className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                        onClick={() => {
                            if (credits > 0) {
                                generate();
                            } else {
                                setOpenSubscriptionModal(true);
                            }
                        }}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="flex items-center">
                                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                        fill="none"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Generating...
                            </span>
                        ) : (
                            <>
                                <img src={sparkles} alt="sparkles" className="w-5 inline-block transform -translate-y-0.5" />&nbsp;&nbsp;Generate
                            </>
                        )}
                    </button>
                </div>
            </div>
            <button className='text-custom-orange font-bold' onClick={() => setSelectedTool('generic-voice')}><u>or write a generic email</u> :)</button>
        </>
    );
}
